import { user } from './user';
import { ui } from './ui';

export const ja = {
	...user,
	...ui,
} as const;

export type TranslationKeys = typeof ja;
